import { Link } from '@tanstack/react-router';
import MetricCard from '@/components/ui/MetricCard.tsx';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';
import { CHART_PALETTE } from '@/components/ui/chartPalette.ts';
import { AvailabilityFieldDto } from '@/features/dashboard/tours/types/AvailabilityFieldDto.ts';
import {
  freePlaces,
  occupancyPercent,
} from '@/features/dashboard/tours/types/availability.utils.ts';
import { pluralForm, pluralize } from '@/utils/pluralize.ts';

interface TourOccupancyCardProps {
  occupancy: AvailabilityFieldDto;
  waitlistCount: number;
  tourId: string;
}

/** Ile miejsc zajętych, ile wolnych i kto czeka w kolejce. */
const TourOccupancyCard = ({
  occupancy,
  waitlistCount,
  tourId,
}: TourOccupancyCardProps) => {
  const { currentCount, limit } = occupancy;
  const percent = occupancyPercent(occupancy);
  const free = freePlaces(occupancy);

  return (
    <MetricCard
      title="Obłożenie"
      value={currentCount}
      // Bez limitu nie ma mianownika ani udziału — nie ma sufitu, do którego
      // dałoby się je odnieść.
      unit={
        limit === null
          ? undefined
          : `z ${limit} ${pluralForm(limit, 'miejsca', 'miejsc', 'miejsc')}`
      }
      share={percent === null ? undefined : `${percent}%`}
      segments={
        percent === null
          ? undefined
          : [{ id: 'taken', pct: percent, color: CHART_PALETTE.accent }]
      }
      footer={[
        {
          id: 'free',
          label: 'Wolne miejsca',
          value: free === null ? <EmptyValue /> : free,
        },
        {
          id: 'waitlist',
          label: 'Lista rezerwowa',
          value: (
            <Link
              to="/app/tours/$tourId/waitlist"
              params={{ tourId }}
              className="underline-offset-2 hover:underline"
            >
              {pluralize(waitlistCount, 'osoba', 'osoby', 'osób')}
            </Link>
          ),
        },
      ]}
    />
  );
};

export default TourOccupancyCard;
